import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { ShopUIProvider } from './context/ShopUIContext';
import { installSessionGuard } from './config/session';

// Must run before the first request goes out, so every API call in the
// app is covered by the expired-session check.
installSessionGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <ShopUIProvider>
          <App />
        </ShopUIProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);
